import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import productStyle from "assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx";

class ProductSection extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={8}>
            <h2 className={classes.title}>Vision, Mission, Value</h2>
            <br />
            <div style={{ textAlign: "left" }}>
              <h3 style={{ color: "grey" }}>
                <b>Vision</b>
              </h3>
              <h4 className={classes.description}>
                We have a vision to redefine consulting business so that our solutions will fit to the latest business dynamics and highly disruptive environments.
              </h4>
              <h3 style={{ color: "grey" }}>
                <b>Mission</b>
              </h3>
              <h4 className={classes.description}>
                Our mission is to bring a real transformative impact on our clients by doing a thorough assessment, helping them to unleash their own potentials, and having higher degree of certainty on results.
              </h4>
              <h3 style={{ color: "grey" }}>
                <b>Values</b>
              </h3>
              <h4 className={classes.description}>
                <ul>
                  <li>
                    <span style={{ color: "grey" }}><b>Grow Together</b></span>
                    <br />
                    As clearly stated on our parent company PT Sandton Sukses Bersama, we fully realize that the only way for us to grow is by taking care of the entire surrounding that connected to us including clients, partners, internal employee, and society in extent.

                </li>
                  <li>
                    <span style={{ color: "grey" }}><b>Transparency</b></span>
                    <br />
                    We communicate openly and continuously on key findings of every steps taken during our training, consulting, and other processes so that both parties solve the real problem without obstacles.
                </li>
                  <li>
                    <span style={{ color: "grey" }}><b>Fidelity</b></span>
                    <br />
                    Being precise and consistent is a key trait for a consulting project to be successful in order to manage calculated risks during the process taken.
                </li>
                  <li>
                    <span style={{ color: "grey" }}><b>Process Oriented</b></span>
                    <br />
                    We believe that the best result can only be achieved through careful process and quality management of all resources. Therefore, we promote best practices and good governance in all of our proposed solutions to our client.
                </li>
                  <li>
                    <span style={{ color: "grey" }}><b>Sustainability</b></span>
                    <br />
                    Sustainability is one of the cornerstone of every organization strategy. Profitability must always consider environmental and social impacts.
                </li>
                </ul>
              </h4>
            </div>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(productStyle)(ProductSection);



// WEBPACK FOOTER //
// ./src/views/AboutPage/Sections/ProductSection1.jsx